import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { UpdateOrderWithFullCoverageInCentralStockInput } from './UpdateOrderWithFullCoverageInCentralStockInput';
import { UpdateOrderWithFullCoverageInCentralStockOutput } from './UpdateOrderWithFullCoverageInCentralStockOutput';

export class UpdateOrderWithFullCoverageInCentralStockService extends HttpServiceBase {

  handle = (input: UpdateOrderWithFullCoverageInCentralStockInput): Promise<Result<UpdateOrderWithFullCoverageInCentralStockOutput> | null> => {
    const promise = this.http.put<Result<UpdateOrderWithFullCoverageInCentralStockOutput>, UpdateOrderWithFullCoverageInCentralStockInput>(
      `${this.baseUrlSislogApi}/v2/order/${input.orderId}/with-full-coverage-in-central-stock`,
      input
    );
    return promise;
  }
}